import styled from 'styled-components';
import backgroundImage from './../../assets/background-header.webp';
interface ResponsiveProps {
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
}


export const Layout = styled.div`
  display: flex;
  flex-direction: column;
`;

export const MainWrapper = styled.div<ResponsiveProps>`
  display: flex;
  gap: 20px;
  background-image: url(${backgroundImage});
  background-size: 100% auto; /* Largura sempre 100%, altura automática */
  background-repeat: repeat-y; /* Repetição somente na vertical */
  background-position: top center; /* Mantém a imagem centralizada horizontalmente */
  gap: 16px;
  min-height: 100vh;
  max-width: 100vw;
  //margin-top: 60px; /* Espaço para o header fixo */
`;